export const ROUTES = {
  HOME: '/',
  THEMES: '/themes/[id]',
  NOT_FOUND: '/404',
} as const;

export enum Pages {
  index = 'index',
  food = 'food',
  housing = 'housing',
  factories = 'factories',
  roads = 'roads',
  water = 'water',
  military = 'military',
  notFound = 'notFound',
}

export const NESTED_ROUTES = [
  'food',
  'housing',
  'factories',
  'roads',
  'water',
  'military',
];

export const generatePathsMap = () => {
  const paths = {};
  paths['/'] = { page: '/' };
  for (const route of NESTED_ROUTES) {
    paths[`themes/${route}`] = {
      page: '/themes/[id]',
      query: { id: route },
    };
  }
  return paths;
};
